// src/redux/settingsPages/accessibility/accessibilitySlice.js
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAccessibilitySettings,
  updateAccessibilitySettings,
  resetAccessibilitySettings,
} from './accessibilityActions';

const initialState = {
  text_scale: 'normal',   // 'normal' | 'large' | 'larger'
  reduced_motion: false,
  high_contrast: false,
  loading: false,
  error: null,
  updating: false,
  updateError: null,
  loaded: false, // distinguishes "still on defaults" from "confirmed defaults from server"
};

const slice = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {
    clearAccessibilityError(state) {
      state.error = null;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccessibilitySettings.pending, (s) => { s.loading = true; s.error = null; })
      .addCase(fetchAccessibilitySettings.fulfilled, (s, a) => {
        s.loading = false;
        s.loaded = true;
        s.text_scale = a.payload?.text_scale ?? 'normal';
        s.reduced_motion = !!a.payload?.reduced_motion;
        s.high_contrast = !!a.payload?.high_contrast;
      })
      .addCase(fetchAccessibilitySettings.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload || 'Failed to load accessibility settings';
      })

      .addCase(updateAccessibilitySettings.pending, (s) => { s.updating = true; s.updateError = null; })
      .addCase(updateAccessibilitySettings.fulfilled, (s, a) => {
        s.updating = false;
        s.loaded = true;
        s.text_scale = a.payload?.text_scale ?? s.text_scale;
        s.reduced_motion = a.payload?.reduced_motion ?? s.reduced_motion;
        s.high_contrast = a.payload?.high_contrast ?? s.high_contrast;
      })
      .addCase(updateAccessibilitySettings.rejected, (s, a) => {
        s.updating = false;
        s.updateError = a.payload || 'Failed to update accessibility settings';
      })

      .addCase(resetAccessibilitySettings.fulfilled, (s, a) => {
        s.text_scale = a.payload?.text_scale ?? 'normal';
        s.reduced_motion = !!a.payload?.reduced_motion;
        s.high_contrast = !!a.payload?.high_contrast;
      });
  },
});

export const { clearAccessibilityError } = slice.actions;
export default slice.reducer;
